<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">查询通话匹配报表</h1>
    <el-row :gutter="12" class="user-options">
      <el-col :span="6">
        <el-date-picker
          v-model="platformData"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="3">
        <el-select style="width: 160px" v-model="channel" placeholder="">
          <el-option
            v-for="(item, itemIndex) in channelsList"
            v-bind:key="itemIndex"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select filterable style="width: 160px" v-model="country" placeholder="">
          <el-option
            v-for="(item, itemIndex) in countryList"
            v-bind:key="itemIndex + 99"
            :label="item.country"
            :value="item.countryCode"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row :gutter="19" class="user-options">
      <el-col :span="3">
        <el-select filterable style="width: 160px" v-model="language" placeholder="">
          <el-option
            v-for="(item, itemIndex) in languageList"
            v-bind:key="itemIndex + 199"
            :label="item.language"
            :value="item.langCode"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-upload
          class="upload-demo"
          ref="upload2"
          action=""
          :limit="1"
          :on-change="changeFile2"
          :auto-upload="false"
        >
          <el-button slot="trigger" type="primary"> 选取用户id白名单文件 </el-button>
        </el-upload>
      </el-col>
      <el-col :span="6">
        <el-button type="warning" @click="getDayChatDetai" :loading="login1">
          查询
        </el-button>
        <el-button type="success" @click="dwnDayChatDetai" :loading="login2">
          下载
        </el-button>
      </el-col>
    </el-row>
    <el-row class="user-options">
      <el-table
        :data="dayChatDetailData"
        style="width: 100%"
        v-loading="login1"
        stripe
        border
      >
        <el-table-column prop="hostLanguage" fixed label="主播语言类别" width="180">
        </el-table-column>
        <el-table-column prop="chatCount" fixed label="通话数量" width="180" sortable>
        </el-table-column>
        <el-table-column prop="chatRate" label="占总比" width="180"> </el-table-column>
        <el-table-column prop="chatTime" label="通话时长" width="180" sortable>
        </el-table-column>
        <el-table-column prop="avgChatTime" label="平均通话时长" width="180" sortable>
        </el-table-column>
        <el-table-column prop="chatGold" label="通话金币消耗" width="180" sortable>
        </el-table-column>
        <el-table-column prop="chatGoldRate" label="通话金币占总消耗比" width="180">
        </el-table-column>

        <el-table-column prop="giftGold" label="礼物金币消耗" width="180" sortable>
        </el-table-column>
        <el-table-column prop="giftGoldRate" label="礼物金币占总消耗比" width="180">
        </el-table-column>
      </el-table>
    </el-row>
  </el-card>
</template>

<script>
import download from "@/utils/download.js";
import { datainfor } from "@/utils/formdata.js";
import { getCountry, getLanguage } from "@/utils/normalApi.js";
export default {
  data() {
    return {
      // 加载
      login1: false,
      login2: false,
      // 用户id白名单 MultipartFile文件
      ridFile: "",
      // 代理名或者代理id
      agentName: "",
      channel: "total",
      channelsList: this.$store.state.channels,
      country: "total",
      countryList: [],
      language: "all",
      languageList: [],
      // 通话日期
      platformData: [datainfor(1), datainfor(1)],
      retainedOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      // 表格数据
      dayChatDetailData: [],
    };
  },
  async created() {
    await this._getLanguage();
    this.getDayChatDetai();
    this._getCountry();
  },
  methods: {
    changeFile2(file) {
      this.ridFile = file.raw;
    },
    async _getLanguage() {
      const res = await getLanguage();
      if (res !== null) {
        this.languageList = res;
        this.language = res[0].langCode;
      }
    },
    // 查询列表
    async getDayChatDetai() {
      this.login1 = true;
      let fordata = new FormData();
      fordata.append("username", this.$store.getters.username);
      fordata.append("token", this.$store.getters.token);
      fordata.append("start", this.platformData[0]);
      fordata.append("end", this.platformData[1]);
      fordata.append("ridFile", this.ridFile);
      fordata.append("country", this.country);
      fordata.append("language", this.language);
      fordata.append("channel", this.channel);
      const { data: res } = await this.$axios({
        method: "post",
        url: this.$store.getters.path.chat_match,
        withCredentials: true,
        data: fordata,
      });
      this.login1 = false;
      if (res.code != 0) return this.$message(res.msg);
      this.dayChatDetailData = res.data;
      this.total = res.data.total;
    },
    async _getCountry() {
      const res = await getCountry();
      if (res !== null) {
        this.countryList = res.countryList;
      }
    },
    // 下载
    async dwnDayChatDetai() {
      this.login2 = true;
      let fordata = new FormData();
      fordata.append("username", this.$store.getters.username);
      fordata.append("token", this.$store.getters.token);
      fordata.append("start", this.platformData[0]);
      fordata.append("end", this.platformData[1]);
      fordata.append("ridFile", this.ridFile);
      fordata.append("country", this.country);
      fordata.append("language", this.language);
      fordata.append("channel", this.channel);
      const res = await this.$axios({
        method: "post",
        url: this.$store.getters.path.download_chat_match,
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
        responseType: "blob",
        data: fordata,
      });

      this.$message.success("开始下载");
      this.login2 = false;
      download(res.data, "获取通话匹配报表" + this.platformData[1]);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.page-container {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;

    .line {
      width: 1440px;
      height: 700px;
    }
  }
}
</style>
